import { alpha, Avatar, Theme, useTheme } from '@mui/material'

import type { TrustedActor } from '@/core/models/trusted-actor.model'
import { getAvatarColor, getInitials } from './avatar'

type Props = {
  actor: TrustedActor
}

export function ActorAvatar({ actor }: Props) {
  const theme = useTheme()
  const color = getAvatarColor(actor.name, theme)
  return (
    <Avatar
      variant="rounded"
      sx={{
        width: 36,
        height: 36,
        fontSize: 12,
        fontWeight: 700,
        color,
        bgcolor: alpha(color, 0.12),
      }}
    >
      {getInitials(actor.name)}
    </Avatar>
  )
}

export type ActorAvatarProps = Props
export type { Theme }
